/*
* Project: LegalPlace assistant
* File: src/globals.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/
import { createStore, applyMiddleware, compose } from 'redux';
import middlewares from './middlewares/middlewares';
import lpReducer from './redux/reducers/root';
import { updateWindow, initializeIndexes, updateConditions } from './logic/re_index';
import lpApp from './app/lp_app';

// add listener to reindex the things.

// initialization of the basic context, with reducers and middleware
/**
 * @description creation of the store,
 */
let store;
let environment = process.env["NODE_ENV"];

if(environment == 'development')
    store = compose(applyMiddleware(...middlewares))(createStore)(lpReducer, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());
else{
    store = compose(applyMiddleware(...middlewares))(createStore)(lpReducer);
}

/**
 * @description create the callback of the indexes
 * Options, variables, multiples, parents, variables parents, conditions
 */
function reorderThings() {
  // let state = store.getState();
  const la = lpApp.action_tracker.last_action;
  if ((la === 'EDIT_VARIABLE_VALUE_') || (la === 'CREATE_FLAT_UI_')) return;

  initializeIndexes();
  updateConditions();
  lpApp.indexes.updateConditions();
  updateWindow();
}

store.subscribe(reorderThings);

export function isDocumentEdited() {
  return store.getState().account_settings.edited_doc;
}

export {store};



// WEBPACK FOOTER //
// ./src/globals.js